// Add `has-error` if field is invalid
const inputs = document.querySelectorAll('input, select, textarea');
if(inputs.length) {
    inputs.forEach((input) => {
        input.addEventListener('invalid', (event) => {
            input.classList.add('has-error');
        }, false);
        input.addEventListener('blur', () => {
            const fieldIsValid = input.checkValidity();
            
            if(fieldIsValid) {
                input.classList.remove('has-error');
            }
        });
    });
}